import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import { IFetchCollectionPayload, IFetchCollectionResponse } from '@framework/state/useFetchCollection';
import { IDataroomListItem } from '../domain/vo/DataroomListItem';

@injectable()
class DataroomListingRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  getList = async (
    payload: IFetchCollectionPayload,
  ): Promise<IFetchCollectionResponse<IDataroomListItem>> => {
    if (payload.perPage === 'all') {
      const {
        perPage,
        page,
        ...otherPayload
      } = payload;
      payload = otherPayload;
    }

    payload = {
      sortBy: 'name',
      sortOrder: 'asc',
      ...payload,
    };

    const request = new Request('dataroom.list', payload);
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default DataroomListingRepository;
